<!-- Trigger: avatar -->
<button class="pm-trigger" type="button" (click)="toggle($event)" pTooltip="Mi cuenta" tooltipPosition="bottom">
  <span class="pm-trigger__initials">{{ initials }}</span>
</button>

<!-- Panel -->
<p-popover #panel styleClass="pm-panel">

  <!-- ── Header: info de usuario ──────────────────────────── -->
  <div class="pm-header">
    <div class="pm-avatar">{{ initials }}</div>
    <div class="pm-header__info">
      <span class="pm-header__name">{{ fullName }}</span>
      <span class="pm-header__email">{{ email }}</span>
      @if (cargo) {
        <span class="pm-header__cargo">{{ cargo }}</span>
      }
    </div>
  </div>

  <div class="pm-divider"></div>

  <!-- ── Idioma ─────────────────────────────────────────── -->
  <div class="pm-language-container">
    <button
      class="pm-language-btn"
      type="button"
      (click)="toggleLanguageMenu($event)"
    >
      <span class="material-symbols-outlined" aria-hidden="true">language</span>
      <span>{{ getCurrentLanguageName() }}</span>
      @if (isLanguageMenuOpen) {
        <span class="material-symbols-outlined" aria-hidden="true">keyboard_arrow_up</span>
      } @else {
        <span class="material-symbols-outlined" aria-hidden="true">keyboard_arrow_down</span>
      }
    </button>

    @if (isLanguageMenuOpen) {
      <div class="pm-language-menu">
        @for (opt of languageOptions; track opt.value) {
          <button
            class="pm-language-option"
            type="button"
            (click)="onLanguageSelected(opt.value)"
            [class.pm-language-option--active]="opt.value === currentLanguage"
          >
            <span>{{ opt.label }}</span>
            @if (opt.value === currentLanguage) {
              <span class="material-symbols-outlined" aria-hidden="true">check</span>
            }
          </button>
        }
      </div>
    }
  </div>

  <!-- ── Navegación ──────────────────────────────────────── -->
  <nav class="pm-menu">
    <button
      class="pm-menu__item"
      type="button"
      (click)="navigateTo('/herramientas/cambiar-contrasena')"
    >
      <div class="pm-menu__icon"><span class="material-symbols-outlined">key</span></div>
      <div class="pm-menu__text">
        <span class="pm-menu__label">Cambiar contraseña</span>
        <span class="pm-menu__desc">Actualiza tu contraseña</span>
      </div>
    </button>
  </nav>

  <div class="pm-divider"></div>

  <!-- ── Apariencia ─────────────────────────────────────── -->
  <div class="pm-section">
    <span class="pm-section__title">Apariencia</span>
    <p-selectButton
      [options]="themeOptions"
      [(ngModel)]="selectedTheme"
      (ngModelChange)="onThemeChange($event)"
      optionLabel="label"
      optionValue="value"
      styleClass="pm-theme-btn">
      <ng-template pTemplate="item" let-opt>
        <div class="pm-theme-opt">
          <i [class]="opt.icon"></i>
          <span>{{ opt.label }}</span>
        </div>
      </ng-template>
    </p-selectButton>
  </div>

  <div class="pm-divider"></div>

  <!-- ── Footer: cerrar sesión ─────────────────────────── -->
  <div class="pm-footer">
    <button class="pm-logout" type="button" (click)="logout()">
      <span class="material-symbols-outlined">logout</span>
      <span>Cerrar sesión</span>
    </button>
  </div>

</p-popover>
